import React from "react";
import { Line } from "react-chartjs-2";

// Styles
import styles from "./../StaffManagment.module.css";

const StaffManagmentLineCharts = (props) => {

    const option = {
        scales: {
            x: {
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
            },
            y: {
                max: props.maximumYScaleLineChart,
                border: {
                    display: false,
                    dash: [4]
                },
            },
        },
        plugins: {
            datalabels: false,
            setSumTotal: false,
            tooltip: {
                backgroundColor: "#F9F9F9",
                borderWidth: 1,
                borderColor: "#D8D8D8",
                cornerRadius: 24,
                textDirection: "rtl",
                titleColor: "#363636",
                titleAlign: "center",
                titleFont: {
                    family: "Vazir",
                    size: 12,
                    weight: 400,
                },
                bodyColor: "#363636",
                bodyAlign: "center",
                bodyFont: {
                    family: "Vazir",
                    size: 12,
                    weight: 400,
                },
                footerColor: "#363636",
                footerAlign: "center",
                footerFont: {
                    family: "Vazir",
                    size: 12,
                    weight: 400,
                },
                padding: 15,
                displayColors: false,
                xAlign: "center",
                yAlign: "bottom",
                interaction: {
                    axis: 'x',
                    mode: 'nearest',
                    intersect: false
                },
                callbacks: {
                    label: function (tooltipItem) {
                        return `${tooltipItem.formattedValue} ${props.dataLineTooltipValue ? props.dataLineTooltipValue : ""}`
                    }
                }
            },
            legend: {
                display: false,
                labels: {
                    font: {
                        family: "Vazir",
                        size: 14
                    }
                }
            },
        }
    }

    return (
        <>
            <div dir="rtl" className={`mt-2 mx-4 px-2`}>
                <div className={`mt-4 p-4 ${styles.total_line_chart_box}`}>
                    {props.children}
                    <Line data={props.dataLineChart} options={option} />
                </div>
            </div>
        </>
    )
}

export default StaffManagmentLineCharts;